import { Toaster as Sonner, type ToasterProps } from "sonner";

import { useTheme } from "@/components/theme-provider";

const Toaster = ({ ...props }: ToasterProps) => {
  // The app's light / dark / system choice (ThemeProvider), not the OS's.
  const { theme } = useTheme();

  return (
    <Sonner
      theme={theme}
      className="toaster group font-mono"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)", 
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
